import { IonButton } from '@ionic/react';
import { useMutations } from '@lidea/shared/data-access/core';
import { Indicator } from '@mantine/core';
import { IconWifi, IconWifiOff } from '@tabler/icons-react';
import { onlineManager } from '@tanstack/react-query';
import { useEffect, useState } from 'react';

const TOOLBAR_ICON_SIZE = 24;

interface OnlineStatusButtonProps {
  className?: string;
  onClick?: () => void;
}
export const OnlineStatusButton: React.FC<OnlineStatusButtonProps> = ({
  className,
  onClick,
}) => {
  const [onlineManagerOnline, setOnlineManagerOnline] = useState(true);
  const { hasPendingMutations, hasPausedMutations, hasFailedMutations } =
    useMutations();

  useEffect(() => {
    setOnlineManagerOnline(onlineManager.isOnline());
    const unsubscribe = onlineManager.subscribe((isOnline) => {
      setOnlineManagerOnline(isOnline);
    });

    // clean up the listener when the component unmounts
    return () => {
      unsubscribe();
    };
  }, []);

  const color = hasPendingMutations
    ? 'orange'
    : hasFailedMutations
    ? 'red'
    : hasPausedMutations
    ? 'violet'
    : 'orange';

  return (
    <Indicator
      color={color}
      disabled={
        !hasPendingMutations && !hasPausedMutations && !hasFailedMutations
      }
      offset={10}
      processing={hasPendingMutations}
      size={12}
      withBorder
    >
      <IonButton
        className={className}
        color={!onlineManagerOnline ? 'danger' : undefined}
        fill="clear"
        onClick={onClick}
      >
        {onlineManagerOnline ? (
          <IconWifi size={TOOLBAR_ICON_SIZE} stroke={1.75} />
        ) : (
          <IconWifiOff size={TOOLBAR_ICON_SIZE} stroke={1.75} />
        )}
      </IonButton>
    </Indicator>
  );
};
